<script>
    import {store} from "./Utils/stores";
    import {progressStore} from "./stores/authStore";
    import {update_video} from "./Utils/RouterUtils.svelte";
    import DiffilcultyBadge from "./DiffilcultyBadge.svelte";
    import {previewUrlForVideo} from "./services/imageService";

    export let video = null;
    import {fade} from "svelte/transition";
    import Debug from "./Utils/Debug.svelte";
    import CardBody from "./CardBody.svelte";
    import CardTitle from "./CardTitle.svelte";
    import CardDescription from "./CardDescription.svelte";
    import CardImage from "./CardImage.svelte";
</script>
{#if video}
    {#if $store.search}
        <div
                class="vec-space-y-4"
                in:fade={{ delay: 0, duration: 200 }}
                on:click
        >
                
                <div>
                    <div style="position:relative;">
                        <img
                                src={ previewUrlForVideo(video)}
                                alt={video.videoTitle}
                                class="img-fluid shadow-sm rounded"
                        />
                    </div>
                </div>
                <CardBody>
                    <CardTitle>{video.videoTitle}</CardTitle>
                    <DiffilcultyBadge difficulty={video.difficulty}/>
                    <CardDescription>{video.shortDescription}</CardDescription>
                </CardBody>
        </div>
    {:else}
        <div
                class="vec-space-y-4"
                in:fade={{ delay: 0, duration: 200 }}
                on:click={update_video(video.slug.current)}
        >
            <div>
            {#if $progressStore.watched[video.slug.current]}
                <div style="position:relative;">
                    <img
                            src={ previewUrlForVideo(video)}
                            alt={video.videoTitle}
                            class="vec-max-w-full vec-h-auto vec-shadow-md vec-rounded-xl vec-cursor-pointer"
                    />
                    <div
                            class="vec-absolute vec-bg-white vec-opacity-70 vec-w-full vec-h-full vec-cursor-pointer
             vec-inset-0 vec-flex vec-flex-col vec-justify-center vec-items-center text-center "
                    >
                        <svg
                                class="vec-w-10 vec-h-10"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg
                        >
                        <div class="vec-font-extrabold vec-text-2xl">
                            <p class=" vec-bg-clip-text vec-font-extrabold vec-text-2xl">
                                Watched
                            </p>
                        </div>
                    </div>
                </div>
            {:else}
                <CardImage
                        src={previewUrlForVideo(video)}
                        alt={video.videoTitle}
                />

            {/if}
            </div>
            <CardBody>
                <CardTitle>{video.videoTitle}</CardTitle>
                <DiffilcultyBadge difficulty={video.difficulty}/>
                <CardDescription>{video.shortDescription}</CardDescription>
            </CardBody>
        </div>
    {/if}
{/if}


<style>
    .card {
        border: none;
        background: none;
    }

    .card-body {
        padding: 0.6rem;
    }

    .card-body p {
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        display: block;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
    }

    img {
        cursor: pointer;
    }
</style>
